exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal .btn-modal-save {\n  padding-left: 3rem !important;\n  padding-right: 3rem !important; }\n", ""]);

// exports
